__turbopack_context__.v({
  "failed": "Steps-module-scss-module__MUkWXW__failed",
  "plenty": "Steps-module-scss-module__MUkWXW__plenty",
  "promo": "Steps-module-scss-module__MUkWXW__promo",
  "promo-wrapper": "Steps-module-scss-module__MUkWXW__promo-wrapper",
  "propositions": "Steps-module-scss-module__MUkWXW__propositions",
  "propositions-wrapper": "Steps-module-scss-module__MUkWXW__propositions-wrapper",
});
